import BaseService from './BaseService'

class SocialMediaService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl, true)
  }
  allowedLocations = (id: string, fetchAll?: boolean) => 
    this.requests.get(`/${id}/accounts${fetchAll ? '?fetchAll=true' : ''}`)
    .then(response =>  ({ ...response.results }))
  getGlobalSettings =  (locationID: string) => 
    this.requests.get(`/global-settings?locationId=${locationID}`)
    .then(response =>  ({ ...response.results }))
}

const instance = new SocialMediaService(BaseService.servicesConfig.SocialMediaService as string)

export default instance